import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

export default class EmailMessageListItem extends React.Component {

    static propTypes = {
        expanded: PropTypes.bool.isRequired,
        collapsible: PropTypes.bool.isRequired,
        message: PropTypes.object.isRequired,
        onExpand: PropTypes.func.isRequired,
        onCollapse: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.onHeaderClick = this.onHeaderClick.bind(this);
        this.toggleThread = this.toggleThread.bind(this);

        this.state = {
            threadExpanded: false
        };

        this.messageElm = null;
        this.threadElm = null;

        this.updateFromProps(props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateFromProps(nextProps);
    }

    updateFromProps(props) {
        if (props.message.body) {
            this.messageElm = <div dangerouslySetInnerHTML={{ __html: props.message.body }}/>;
/*
            let messageElm = document.createElement('div');
            messageElm.innerHTML = props.message.body;

            let threadElm = messageElm.lastElementChild;
            if (threadElm) {
                messageElm.removeChild(threadElm);
                this.threadElm = <div dangerouslySetInnerHTML={{ __html: threadElm.innerHTML }}/>;
            }

            this.messageElm = <div dangerouslySetInnerHTML={{ __html: messageElm.innerHTML }}/>;
*/
        }
    }

    onHeaderClick() {
        let messageId = this.props.message.id;
        if (this.props.expanded) {
            this.props.onCollapse(messageId);
        } else {
            this.props.onExpand(messageId);
        }
    }

    toggleThread() {
        this.setState({
            threadExpanded: !this.state.threadExpanded
        });
    }

    renderHeaderFirstLine() {
        let m = moment(this.props.message.timestamp);
        return (
            <div className="emailMessageFirstLine">
                <div className="emailMessageFrom">{this.renderContactList(this.props.message.from)}</div>
                <div className="emailMessageTime">{m.format('llll')} ({m.fromNow()})</div>
            </div>
        );
    }

    renderHeaderSecondLine() {
        if (this.props.expanded) {
            let cc = null;
            if (this.props.message.cc.length) {
                cc = <span>; cc: {this.renderContactList(this.props.message.cc)}</span>;
            }
            return (
                <div className="emailMessageSecondLine">
                    <div className="emailMessageTo">to {this.renderContactList(this.props.message.to)}{cc}</div>
                </div>
            );
        } else {
            return (
                <div className="emailMessageSecondLine">
                    <div className="emailMessageSnippet ellipsisTruncate">{this.props.message.snippet}</div>
                </div>
            );
        }
    }

    renderContactList(contacts) {
        return _.flatMap(contacts, (contact, index, array) => {
            return [
                <span key={'name-' + index} className="emailMessageContactName">{contact.name}</span>,
                ' ',
                <span key={'email-' + index} className="emailMessageContactEmail">&lt;{contact.email}&gt;</span>,
                (index < array.length - 1) ? ', ' : null
            ]
        });
    }

    messageBody() {
        let message = this.messageElm || "Loading...";
        let threadExpandHandle = null;
        let thread = null;
        if (this.threadElm) {
            threadExpandHandle = <div className="emailMessageThreadExpandButton" onClick={this.toggleThread}>...</div>;
            if (this.state.threadExpanded) {
                thread = this.threadElm;
            }
        }
        return (
            <div className="emailMessageBody">
                {message}
                {threadExpandHandle}
                {thread}
            </div>
        );
    }

    render() {
        let className;
        let messageBody = null;
        let onClick = null;

        if (this.props.expanded) {
            className = "emailMessageExpanded";
            messageBody = this.messageBody();
        } else {
            className = "emailMessageCollapsed";
        }

        if (this.props.collapsible) {
            className += " collapsible";
            onClick = this.onHeaderClick;
        }

        return (
            <div className={"emailMessage " + className}>
                <div className="emailMessageHeader" onClick={onClick}>
                    <div className="emailMessageAvatar"/>
                    <div className="emailMessageHeaderLines">
                        {this.renderHeaderFirstLine()}
                        {this.renderHeaderSecondLine()}
                    </div>
                </div>
                {messageBody}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/plugins/emailPlugin/EmailMessageListItem.js